import { SVGProps } from 'react'

const MoneySendIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.1082 10.6482C17.1082 10.3107 16.8346 10.0371 16.4971 10.0371C16.1596 10.0371 15.886 10.3107 15.886 10.6482V11.1814H15.146C13.6531 11.1814 12.5111 12.454 12.5111 13.9204C12.5111 14.6259 12.6654 15.2117 13.0271 15.6723C13.3816 16.1237 13.8604 16.3567 14.2966 16.512L14.2965 16.512L14.301 16.5136L15.886 17.0665V20.2944H15.4191C14.6683 20.2944 13.998 19.648 13.998 18.7694C13.998 18.3552 13.6623 18.0194 13.248 18.0194C12.8338 18.0194 12.498 18.3552 12.498 18.7694C12.498 20.4129 13.7778 21.7944 15.4191 21.7944H15.886V22.3482C15.886 22.6857 16.1596 22.9593 16.4971 22.9593C16.8346 22.9593 17.1082 22.6857 17.1082 22.3482V21.7944H17.863C19.3529 21.7944 20.498 20.5381 20.498 19.0554C20.498 18.3546 20.3429 17.7705 19.9833 17.3101C19.6304 16.8581 19.1535 16.6208 18.7125 16.4638L18.7126 16.4638L18.7081 16.4623L17.1082 15.9042V12.6814H17.59C18.3408 12.6814 19.0111 13.3279 19.0111 14.2064C19.0111 14.6206 19.3468 14.9564 19.7611 14.9564C20.1753 14.9564 20.5111 14.6206 20.5111 14.2064C20.5111 12.563 19.2313 11.1814 17.59 11.1814H17.1082V10.6482ZM15.886 12.6814H15.146C14.559 12.6814 14.0111 13.2028 14.0111 13.9204C14.0111 14.411 14.1167 14.6311 14.2068 14.7458C14.3038 14.8694 14.468 14.9806 14.7974 15.0981L15.886 15.4778V12.6814ZM17.1082 17.4928V20.2944H17.863C18.4532 20.2944 18.998 19.7827 18.998 19.0554C18.998 18.5732 18.8932 18.3513 18.8011 18.2333C18.7024 18.107 18.5364 17.9936 18.2117 17.8777L17.1082 17.4928Z"
        fill={props.color ? props.color : 'white'}
      />
      <path
        d="M16.5059 3.49414C9.32986 3.49414 3.50586 9.31814 3.50586 16.4941C3.50586 21.6161 6.46987 26.0491 10.7859 28.1681"
        stroke={props.color ? props.color : 'white'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.5039 16.5098C29.5039 23.6858 23.6799 29.5098 16.5039 29.5098"
        stroke={props.color ? props.color : 'white'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.4959 8.69414V3.49414H24.2959"
        stroke={props.color ? props.color : 'white'}
        strokeWidth="1.22222"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23 9.99414L29.5 3.49414"
        stroke={props.color ? props.color : 'white'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default MoneySendIcon
